const drivers = {
  drivers: 'נהגים',

  createNew: 'חדש',

  headerButtons: {
    create: {
      createBtn: 'הוסף',
    },

    import: 'ייבא',
  },

  import: {
    title: 'העלאת נהגים',
  },

  toast: {
    error: {
      badResponse: '[נהגים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  table: {
    headers: {
      displayName: 'שם',
      name: 'שם',
      driverStatus: 'סטטוס',
      email: 'אימייל',
      vehicle: 'רכב',
      phoneNumber: 'מספר טלפון',
      address: 'כתובת',
      firstTripDistance: 'מרחק מקסימלי לנסיעה ראשונה',
      action: 'פעולה',
      attributes: 'מאפיינים',
      locations: 'מיקומים',
      areas: 'אזורים',
      excludedProfiles: 'פרופילים לא כלולים',
    },
    statusOptions: {
      online: 'מקוון',
      offline: 'לא מקוון',
      break: 'הפסקה',
      enRoute: 'בנסיעה',
      suspended: 'מושעה',
    },
    viewOptions: {
      showSuspended: 'הצג מושעים',
      showUnsuspended: 'הצג לא מושעים',
    },
    filters: {
      status: 'סטטוס',
      vehicles: 'רכבים',
      areas: 'אזורים',
      services: 'שירותים',
      suppliers: 'ספקים',
      locations: 'מיקומים',
      airportLocations: 'מיקומי שדה תעופה',
      attributes: 'מאפיינים',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    submit: {
      success: 'נהג נוצר בהצלחה',
      error: 'לא ניתן ליצור נהג עקב שגיאת שרת פנימית',
    },
  },

  update: {
    submit: {
      success: 'נהג עודכן בהצלחה',
      error: 'לא ניתן לעדכן נהג עקב שגיאת שרת פנימית',
    },
    formTabs: {
      informationTab: 'מידע',
      notesTab: 'הערות',
      historyTab: 'היסטוריה',
    },
    toast: {
      toastResetSuccess: 'דוא"ל לאיפוס סיסמה נשלח בהצלחה.',
      toastError: 'משהו השתבש\nאנא נסה שוב.',
      toastRemoveDriverSuccess: 'נהג נמחק בהצלחה',
    },
    driverStatusOptions: {
      activate: 'בטל השעיה',
      deactivate: 'השעיה',
      statusActive: 'פעיל',
      statusInactive: 'לא פעיל',
      statusOffline: 'לא מקוון',
      statusOnline: 'מקוון',
      statusEnRoute: 'בנסיעה',
      statusBreak: 'הפסקה',
      popUpOptions: {
        popupTitleActive: 'השעיית נהג',
        popupTitleDeactivation: 'בטל השעיית נהג',
        popupTitleUnsuspend: 'סיבת ביטול השעיה',
        popupSubTitleDeactivation: 'בחר את סיבת ההשעיה',
        popupActionActive: 'בטל השעיית נהג',
        popupActionDeactivate: 'השעיית נהג',
      },
    },
    modalRemoveConfirm: {
      header: 'אזהרה!',
      body: 'האם אתה בטוח שברצונך למחוק נהג זה?',
      confirmBtn: 'מחק',
    },
  },
  deleteModal: {
    header: 'מחק נהגים',
    body: 'אתה עומד למחוק {{num}} נהגים.',
    success: 'נהגים נמחקו בהצלחה',
  },

  forms: {
    header: {
      createDriver: {
        title: 'הוסף',
      },

      updateDriver: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      personalDetails: {
        header: 'פרטים אישיים',
        fields: {
          firstName: 'שם פרטי',
          lastName: 'שם משפחה',
          name: 'שם תצוגה',
          phone: 'מספר טלפון',
          email: 'כתובת אימייל',
          password: 'סיסמה',
        },
      },
      areaSettings: {
        header: 'הגדרות אזור',
        fields: {
          areas: 'אזורים',
          mode: 'מצב',
          priority: 'עדיפות',
          modeOptions: {
            allStops: 'כל התחנות',
            firstPickDrop: 'איסוף ראשון / הורדה אחרונה',
            legAOrigin: 'A מוצא מקטע',
          },
          priorityOptions: {
            low: 'נמוך',
            medium: 'בינוני',
            high: 'גבוה',
            strict: 'קפדני',
          },
        },
      },

      locationsSettings: {
        header: 'הגדרות מיקומים',
        fields: {
          locations: 'מיקומים',
          enableInBetweenRides: 'אפשר נסיעות ביניים',
        },
      },

      vehicles: {
        header: 'רכבים שצוותו',
        fields: {
          available: 'רכבים זמינים',
          current: 'רכב נוכחי',
        },
      },
      address: {
        header: 'כתובת התחלה',
        fields: {
          mainAddress: 'כתובת ראשית',
          firstTripDistance: 'מרחק מקסימלי לנסיעה ראשונה',
          alt: 'כתובת חלופית',
        },
      },
      settings: {
        header: 'הגדרות נוספות',
        fields: {
          services: 'שירותים',
          areas: 'אזורים',
          externalId: 'מזהה חיצוני',
          ignoreDropoffTime: 'התעלם מזמן הורדה',
          ignoreDropoffTimeOptions: {
            bySystemSettings: 'לפי הגדרות מערכת',
            enabled: 'מופעל',
            disabled: 'כבוי',
          },
          shiftBuffer: 'באפר משמרת',
        },
      },
      supplier: {
        header: 'ספקים',
        fields: {
          suppliers: 'ספקים',
        },
      },
      allowSharedRides: {
        header: 'אפשר נסיעות משותפות',
        fields: {
          allowSharedRides: 'אפשר נסיעות משותפות',
        },
      },
      attributes: {
        header: 'מאפיינים',
      },
      excludedProfiles: {
        header: 'פרופילים מוחרגים',
        dualList: {
          profilesList: {
            header: 'רשימת פרופילים',
          },
          excludedList: {
            header: 'פרופילים מוחרגים',
          },
        },
      },
      buttons: {
        btnResetPassword: 'איפוס סיסמה',
        btnDelete: 'מחק',
      },
    },
  },
};

export default drivers;
